module.exports = __webpack_public_path__ + "img/b-class.4ca147a5.jpg";